import { useMemo } from 'react'
import { SelectOption } from '../../../../../../model/selectOption'
import { useTeamSelectData } from './useTeamSelectData'

type UseTeamSelectOptionsProps = {
  snapshotUuid: string
}

type TeamSelectOptions = {
  options: SelectOption[]
  parentMap: Record<string, string>
  isLoading: boolean
}

export const useTeamSelectOptions = ({
  snapshotUuid,
}: UseTeamSelectOptionsProps): TeamSelectOptions => {
  const { rows, isLoading } = useTeamSelectData({ snapshotUuid })

  return useMemo(() => {
    const options: SelectOption[] = rows.map(row => ({
      value: row.uuid,
      name: row.displayName,
    }))
    return { options, parentMap: {}, isLoading }
  }, [rows, isLoading])
}
